import iconEmployee from "../assets/images/sider/employee.svg";
import iconSourceOfGoods from "../assets/images/sider/sourceofgoods.svg";
import iconSell from "../assets/images/sider/sell.svg";
import iconSales from "../assets/images/sider/sales.svg";
import iconCategory from "../assets/images/sider/category.svg";
import iconAdmin from "../assets/images/sider/Frame.svg";
import { ROLES_CONFIG } from ".";

// Khối của nhân viên, khớp EmployeeDepartmentTypeEnum ở BE (employee.model.js)
export const EMPLOYEE_DEPARTMENT = {
  SUPPORT_BUSINESS: 0, // Khối hỗ trợ kinh doanh
  BUSINESS: 1, // Khối kinh doanh
  MANAGER: 2, // Khối giám đốc
};

// Phòng ban (khối hỗ trợ kinh doanh) dùng để ẩn/hiện nhóm menu ở Sider.
// Chỉ ẩn thêm, không cấp quyền: menu vẫn phải qua kiểm tra role như cũ.
export const MENU_DEPARTMENT = {
  HCNS: "HCNS", // Bộ phận hành chính nhân sự
  KT: "KT", // Phòng kế toán: thấy hết các nhóm menu (trừ Cài đặt)
  HTBH: "HTBH", // Bộ phận HTBH
};

// Nhận diện phòng ban của user theo tên phòng ban (so sánh không dấu, chữ thường;
// từ khoá gõ có dấu/viết hoa cũng được, Sider tự chuẩn hoá trước khi so).
export const MENU_DEPARTMENT_KEYWORDS = {
  [MENU_DEPARTMENT.HCNS]: ["phong hanh chinh nhan su"],
  [MENU_DEPARTMENT.KT]: ["phong ke toan"],
  [MENU_DEPARTMENT.HTBH]: ["Hỗ trợ bán hàng - CRM"],
};

export const enumMenu = [
  {
    path: "#",
    name: "Quản lý nhân sự",
    icon: iconEmployee,
    departments: [MENU_DEPARTMENT.HCNS, MENU_DEPARTMENT.KT],
    role: ROLES_CONFIG.MENU.MENU_QLNS.role,
    children: [
      {
        path: "/",
        name: "Quản lý nhân viên",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_QLNV.role,
      },
      {
        path: "/timekeeping",
        name: "Quản lý chấm công",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_QLCC.role,
      },
      {
        path: "/register-checkin",
        name: "Quản lý đăng kí chấm công ngoài",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_RCI.role,
      },
      {
        path: "/on-leave",
        name: "Xin nghỉ phép",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_XNP.role,
      },
      {
        path: "/job-title",
        name: "Xác nhận công và chức danh hàng tháng",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_XNC_AND_CDHT.role,
      },
      {
        path: "/receive-salary",
        name: "Xin nhận lương",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_XNL.role,
      },
      {
        path: "/relative-form-request",
        name: "Phiếu đăng ký cộng tác viên",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_PDKNT.role,
      },
      {
        path: "/make-up-work-request",
        name: "Đăng ký làm bù",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN
          .MSH_MAKE_UP_WORK_REQUEST_MANAGEMENT.role,
      },
      {
        path: "/attendance-summary",
        name: "Quản lý chuyên cần",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_CC.role,
      },
      {
        path: "/activity-log",
        name: "Quản lý đăng nhập",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.MSH_DEVICE_ACTIVITY_LOG.role,
      },
      {
        path: "/device-manager",
        name: "Quản lý thiết bị",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_DEVICE_MANAGER.role,
      },
      {
        path: "/fuel-allowance",
        name: "Quản lý xăng xe",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_FUEL_ALLOWANCE.role,
      },
      {
        path: "/employee-stop-working",
        name: "Thông báo nhân viên dừng hoạt động",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_QLNV.role,
      },
      {
        path: "/employee-kpi-list",
        name: "Đánh giá nhân sự",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_QLNV.role,
      },
      {
        path: "/referral-earning",
        name: "Thưởng giới thiệu",
        role: ROLES_CONFIG.MENU.MENU_QLNS.CHILDREN.CHILDREN_QLNV.role,
      },
    ],
  },
  {
    path: "#",
    name: "Quản lý nguồn hàng",
    icon: iconSourceOfGoods,
    departments: [MENU_DEPARTMENT.KT, MENU_DEPARTMENT.HTBH],
    role: ROLES_CONFIG.MENU.MENU_QLNH.role,
    children: [
      {
        path: "/project-management",
        name: "Quản lý dự án",
        role: ROLES_CONFIG.MENU.MENU_QLNH.CHILDREN.CHILDREN_QLDA.role,
      },
      {
        path: "/apartments",
        name: "Quản lý sản phẩm và căn hộ",
        role: ROLES_CONFIG.MENU.MENU_QLNH.CHILDREN.CHILDREN_QLSP_AND_CH.role,
      },
      {
        path: "/booking",
        name: "Đợt nhận booking",
        role: ROLES_CONFIG.MENU.MENU_QLNH.CHILDREN.CHILDREN_DN_BOOKING.role,
      },
      {
        path: "/open-for-sale",
        name: "Quản lý đợt mở bán",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QLDMB.role,
      },
      {
        path: "/design-background",
        name: "Quản lý banner",
        role: ROLES_CONFIG.MENU.MENU_QLNH.CHILDREN.CHILDREN_QL_BANNER.role,
      },
    ],
  },
  {
    path: "#",
    name: "Quản lý bán hàng",
    icon: iconSell,
    departments: [MENU_DEPARTMENT.KT, MENU_DEPARTMENT.HTBH],
    role: ROLES_CONFIG.MENU.MENU_QLBH.role,
    children: [
      {
        path: "/customer",
        name: "Quản lý khách hàng",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QLKH.role,
      },
      {
        path: "/customer-care",
        name: "Chăm sóc khách hàng",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QLKH.role,
      },
      {
        path: "/customerUpdateRequest",
        name: "Quản lý phiếu chỉnh sửa khách hàng",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_PCSKH.role,
      },
      {
        path: "/transfer-requests",
        name: "Quản lý phiếu đăng ký chuyển giao dịch",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_TRANSFER_REQUESTS
          .role,
      },
      {
        path: "/bookingManagement",
        name: "Quản lý booking",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QL_BOOKING.role,
      },
      {
        path: "/locking",
        name: "Quản lý locking",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QL_LOCKING.role,
      },
      {
        path: "/ttkq",
        name: "Xác nhận TTKQ",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_XNTTKQ.role,
      },
      {
        path: "/hdmb",
        name: "Xác nhận HĐMB",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_XNHDMB.role,
      },
      {
        path: "/service-fee-management",
        name: "Quản lý đối chiếu PDV",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QL_LOCKING.role,
      },
      {
        path: "/step-commission",
        name: "Quản lý thanh toán PDV",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN.CHILDREN_QL_LOCKING.role,
      },
      {
        path: "/broker-debt-certificate",
        name: "Quản lý tạm giữ CCMG",
        role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN
          .CHILDREN_QL_MSH_BROKER_DEBT_CERTIFICATE_MANAGEMENT.role,
      },
      // Tạm ẩn khỏi menu (route /broker-debt-disbursement vẫn còn trong
      // routes/index.js), bỏ comment khi cần dùng lại.
      // {
      //   path: "/broker-debt-disbursement",
      //   name: "Bảng ghi thanh toán công nợ chứng chỉ môi giới",
      //   role: ROLES_CONFIG.MENU.MENU_QLBH.CHILDREN
      //     .CHILDREN_QL_MSH_BROKER_DEBT_CERTIFICATE_MANAGEMENT.role,
      // },
    ],
  },
  {
    path: "#",
    name: "Quản lý doanh số",
    icon: iconSales,
    departments: [MENU_DEPARTMENT.KT, MENU_DEPARTMENT.HTBH],
    role: ROLES_CONFIG.MENU.MENU_QLDS.role,
    children: [
      // {
      //   path: "/commission-confirmation",
      //   name: "Xác nhận phí dịch vụ",
      //   role: ROLES_CONFIG.MENU.MENU_QLDS.CHILDREN.CHILDREN_XNPDV.role,
      // },
      {
        path: "/sales-management",
        name: "Quản lý doanh số",
        role: ROLES_CONFIG.MENU.MENU_QLDS.CHILDREN.CHILDREN_QLDS.role,
      },
      {
        path: "/statement",
        name: "Báo cáo",
        role: ROLES_CONFIG.MENU.MENU_QLDS.CHILDREN.CHILDREN_BC.role,
      },
      // {
      //   path: "/service-fee",
      //   name: "Phí dịch vụ",
      //   role: ROLES_CONFIG.MENU.MENU_QLDS.CHILDREN.CHILDREN_DV.role,
      // },
    ],
  },
  {
    path: "#",
    name: "Quản lý danh mục",
    icon: iconCategory,
    // Không khai báo `departments` => tất cả phòng ban đều xem được
    role: ROLES_CONFIG.MENU.MENU_QLDM.role,
    children: [
      {
        path: "/personnel-categories",
        name: "Nhân sự",
        role: ROLES_CONFIG.MENU.MENU_QLDM.CHILDREN.CHILDREN_NS.role,
      },
      {
        path: "/on-leave-categories",
        name: "Công và nghỉ phép",
        role: ROLES_CONFIG.MENU.MENU_QLDM.CHILDREN.CHILDREN_C_AND_NP.role,
      },
      {
        path: "/project-categories",
        name: "Dự án",
        role: ROLES_CONFIG.MENU.MENU_QLDM.CHILDREN.CHILDREN_DA.role,
      },
      // {
      //   path: "/product-categories",
      //   name: "Sản phẩm",
      //   role: ROLES_CONFIG.MENU.MENU_QLDM.CHILDREN.CHILDREN_SP.role,
      // },
    ],
  },
  {
    path: "#",
    name: "Cài đặt",
    icon: iconAdmin,
    departments: [], // Chỉ Ban giám đốc
    // Chỉ khối giám đốc (department = 2) thấy, kể cả user khác có role ALL
    employeeDepartments: [EMPLOYEE_DEPARTMENT.MANAGER],
    role: ROLES_CONFIG.MENU.MENU_QL_SETTING.role,
    children: [
      {
        path: "/admin-management",
        name: "Quản lý admin",
        role: ROLES_CONFIG.MENU.MENU_QL_SETTING.CHILDREN.CHILDREN_ADMIN.role,
      },
      {
        path: "/setting-management",
        name: "Cài đặt",
        role: ROLES_CONFIG.MENU.MENU_QL_SETTING.CHILDREN.CHILDREN_SETTING.role,
      },
    ],
  },
];

export const DataSetting = {
  MSH_GROUP: "mshgroup",
  PLACE_CHECKIN_ID: "CHECKIN_PLACE_DEFAULT_ID",
  PLACE_REGISTER_CHECKIN_ID: "PLACE_REGISTER_CHECKIN_ID",
  LEAVERE_QUEST_MORE_SHORT_TERM: "LEAVEREQUESTMORESHORTTERM",
  LEAVERE_QUEST_MORE_LONG_TERM: "LEAVEREQUESTMORELONGTERM",
  ISSMTP: "ISSMTP",
  CHECKIN_RADIUS: "CHECKIN_RADIUS",
  MAX_FILE_SIZE: "MAX_FILE_SIZE",
  BLOCK_CHECKIN: "BLOCK_CHECKIN",
  HALF_DAY_LEAVE_AFTERNOON_START: "HALF_DAY_LEAVE_AFTERNOON_START",
  EMAIL_USER: "EMAIL_USER",
  EMAIL_PASSWORD: "EMAIL_PASSWORD",
  DATE_PROFILE_COMPLETE_EMPLOYEE: "DATE_PROFILE_COMPLETE_EMPLOYEE",
  latest_employee_id: "latest_employee_id",
  DATE_DELETE_TRANSACTION_HISTORY: "DATE_DELETE_TRANSACTION_HISTORY",
  BLOCK_CHECK_IN_TIME: "BLOCK_CHECK_IN_TIME",
  DEVICE_ENFORCE_LOGIN: "DEVICE_ENFORCE_LOGIN",
  DEVICE_WHITELIST_BYPASS: "DEVICE_WHITELIST_BYPASS",
  // Chấm công luồng mới: đăng ký thiết bị + địa điểm chấm công
  CHECKIN_V2_ENABLED: "CHECKIN_V2_ENABLED",
  CHECKIN_V2_APPLY_DATE: "CHECKIN_V2_APPLY_DATE",
  // Nhắc chấm vào / chấm ra trước bao nhiêu phút
  CHECKIN_REMINDER_MINUTES: "CHECKIN_REMINDER_MINUTES",
  // Xăng xe: bật => chỉ NV nhận xăng xe mới phải chấm ra (từ ngày áp dụng nếu có)
  FUEL_ALLOWANCE_ENABLED: "FUEL_ALLOWANCE_ENABLED",
  FUEL_ALLOWANCE_APPLY_DATE: "FUEL_ALLOWANCE_APPLY_DATE",
  // Hạn gửi đơn xăng xe: từ ngày 1 đến ngày này hàng tháng (trống => 10)
  FUEL_REQUEST_DEADLINE_DAY: "FUEL_REQUEST_DEADLINE_DAY",
  // Số tiền từng mức xăng xe (trống => 3tr / 5tr / 7tr)
  FUEL_LEVEL_1_AMOUNT: "FUEL_LEVEL_1_AMOUNT",
  FUEL_LEVEL_2_AMOUNT: "FUEL_LEVEL_2_AMOUNT",
  FUEL_LEVEL_3_AMOUNT: "FUEL_LEVEL_3_AMOUNT",
  // Đơn xăng xe: true / chưa có = HCNS duyệt ngay, false = phải qua bước 1 quản lý
  FUEL_REQUEST_HCNS_DIRECT: "FUEL_REQUEST_HCNS_DIRECT",
  // Chấm công ngoài: NV chỉ gửi đơn trong ngày trước giờ này (HH:mm, trống => 10:00)
  REGISTER_CHECKIN_DEADLINE: "REGISTER_CHECKIN_DEADLINE",
  // Đơn chỉnh sửa công: true / chưa có = HCNS duyệt ngay, false = phải qua bước 1 quản lý
  CHECKIN_CORRECTION_HCNS_DIRECT: "CHECKIN_CORRECTION_HCNS_DIRECT",
  // Gửi thông báo đẩy app + web: false = không gửi (BE local chạy DB clone từ live)
  PUSH_NOTIFICATION_ENABLED: "PUSH_NOTIFICATION_ENABLED",
  // Thưởng giới thiệu: số ngày đi làm cần đạt + tiền thưởng từng mốc (trống => mặc định)
  REFERRAL_MILESTONE_1_REQUIRED_DAY: "REFERRAL_MILESTONE_1_REQUIRED_DAY",
  REFERRAL_MILESTONE_1_AMOUNT: "REFERRAL_MILESTONE_1_AMOUNT",
  REFERRAL_MILESTONE_1_HCNS_AMOUNT: "REFERRAL_MILESTONE_1_HCNS_AMOUNT",
  REFERRAL_MILESTONE_2_REQUIRED_DAY: "REFERRAL_MILESTONE_2_REQUIRED_DAY",
  REFERRAL_MILESTONE_2_AMOUNT: "REFERRAL_MILESTONE_2_AMOUNT",
  REFERRAL_MILESTONE_2_HCNS_AMOUNT: "REFERRAL_MILESTONE_2_HCNS_AMOUNT",
};

export const TIMEZONE = "Asia/Ho_Chi_Minh";

export const StatusProject = [
  // {
  //   key: '',
  //   value: "Tất cả",
  // },
  {
    key: "OPEN",
    value: "Dự án đang mở",
  },
  {
    key: "CLOSE",
    value: "Dự án đã đóng",
  },
];

export const StatusIsAllowTtkq = [
  // {
  //   key: 0,
  //   value: "Tất cả",
  // },
  {
    key: 1,
    value: "Cho phép lên TTKQ/VBTT/HĐTHNV",
  },
  {
    key: 2,
    value: "Không cho phép lên TTKQ/VBTT/HĐTHNV",
  },
];

export const StatusIsProjectMechanismParameters = [
  // {
  //   key: 0,
  //   value: "Tất cả",
  // },
  {
    key: 1,
    value: "Đã cập nhật",
  },
  {
    key: 2,
    value: "Chưa cập nhật",
  },
];

export const priceFilter = [
  {
    key: 1,
    value: "Dưới 1 tỷ",
  },
  {
    key: 2,
    value: "Từ 1 tỷ đến 3 tỷ",
  },
  {
    key: 3,
    value: "Từ 3 tỷ đến 5 tỷ",
  },
  {
    key: 4,
    value: "Trên 5 tỷ",
  },
];

export const GenderCustomers = [
  {
    key: "1",
    value: "Nam",
  },
  {
    key: "2",
    value: "Nữ",
  },
  {
    key: "3",
    value: "Khác",
  },
];

export const TypeCustomers = [
  // {
  //   key: '',
  //   value: "Tất cả",
  // },
  {
    key: "1",
    value: "Cá nhân",
  },
  {
    key: "2",
    value: "Doanh nghiệp",
  },
];

export const RankCustomers = [
  {
    key: "MEMBER",
    value: "Thành viên",
  },
  {
    key: "SILVER",
    value: "Bạc",
  },
  {
    key: "GOLD",
    value: "Vàng",
  },
  {
    key: "DIAMOND",
    value: "Kim cương",
  },
];

export const GetLockings = [
  // {
  //   key: '',
  //   value: "Tất cả",
  // },
  {
    key: "1",
    value: "Đã lên locking",
  },
  {
    key: "2",
    value: "Chưa lên locking",
  },
];

export const GetTtkqHdmbs = [
  // {
  //   key: '',
  //   value: "Tất cả",
  // },
  {
    key: "1",
    value: "Đã lên TTKQ/HĐMB",
  },
  {
    key: "2",
    value: "Chưa lên TTKQ/HĐMB",
  },
];

export const WorkingDayRates = [
  {
    value: 0.25,
    label: "0.25",
  },
  {
    value: 0.5,
    label: "0.5",
  },
  {
    value: 1,
    label: "1",
  },
];

export const StatusApartMent = [
  {
    key: -1,
    value: "Tất cả căn hộ",
  },
  {
    key: 1,
    value: "Căn hộ đã bán",
  },
  {
    key: 2,
    value: "Căn hộ chưa bán",
  },
];

export const StatusTransactionHistory = {
  PENDING: "PENDING",
  HANDLED: "HANDLED",
};

export const TypeLogs = [
  { key: "BOOKING", value: "BOOKING" },
  { key: "LOCKING", value: "LOCKING" },
  { key: "TTKQ", value: "TTKQ" },
  { key: "HDMB", value: "HĐMB" },
  { key: "CUSTOMER", value: "Khách hàng" },
  { key: "CUSTOMER_UPDATE_REQUEST", value: "Phiếu chỉnh sửa khách hàng" },
  { key: "APARTMENT", value: "Sản phẩm / căn hộ" },
  { key: "AGENT", value: "Đại lý" },
  { key: "PROJECT", value: "Dự án" },
  { key: "EMPLOYEE", value: "Nhân viên" },
  { key: "CHECKIN", value: "Chấm công" },
  { key: "OTHER", value: "Khác" },
];

export const ActionLogs = [
  { key: "CREATE", value: "Tạo mới" },
  { key: "UPDATE", value: "Chỉnh sửa" },
  { key: "DELETE", value: "Xóa" },
  { key: "APPROVED", value: "Trạng thái chấp nhận" },
  { key: "REFUND", value: "Trạng thái hoàn trả" },
  { key: "REJECTED", value: "Trạng thái từ chối" },
  { key: "EDITING", value: "Trạng thái yêu cầu chỉnh sửa" },
  { key: "SHARE", value: "Chia sẻ" },
  { key: "REVERT", value: "Trở về trạng thái tạo mới" },
  { key: "TRANSFER", value: "Chuyển đổi" },
  { key: "CANCEL", value: "Hủy phiếu tạo khách hàng" },
  { key: "PENDING_RETURN_REQUEST", value: "Chờ duyệt hoàn trả" },
  { key: "REJECT_RETURN_REQUEST", value: "Từ chối hoàn trả" },
  { key: "CONFIRM_COMMISSION", value: "Xác nhận phí dịch vụ" },
  { key: "UPDATE_CONFIRM", value: "Cập nhật xác nhận" },
  { key: "CLOSE", value: "Đóng dự án" },
  { key: "OPEN", value: "Mở dự án" },
  { key: "UPDATE_PASSWORD", value: "Cập nhập mật khẩu" },
  { key: "VERIFY_CHECKIN_PLACE", value: "Xác nhận đại chỉ chấm công" },
  { key: "VERIFY_BSS_ID", value: "Xác nhận BSSID" },
  { key: "VERIFY_QR_CODE", value: "Xác nhận QR Code" },
  { key: "VERIFY_IMAGE", value: "Xác nhận ảnh chấm công" },
  { key: "COMPLETE_CHECKIN", value: "Hoàn thành chấm công" },
  { key: "COMPLETE_CHECKIN", value: "Hoàn thành chấm công" },
  { key: "COMPLETE_CHECKIN", value: "Hoàn thành chấm công" },
  { key: "COMPLETE_CHECKIN", value: "Hoàn thành chấm công" },
  { key: "GET_LOCATION", value: "Lấy ra vị trí" },
  {
    key: "GET_CHECK_IN_RADIUS_SETTING_NAME",
    value: "Lấy ra bán kính chấm công mặc định",
  },
  {
    key: "CHECK_IN_DEFAULT_SETTING_NAME",
    value: "Lấy ra địa chỉ chấm công mặc định",
  },
  { key: "OTHER", value: "Khác" },
];

export const TypeTransferRequests = {
  BOOKING: "BOOKING",
  LOCKING: "LOCKING",
  TTKQ: "TTKQ",
  SALESCONTRACT: "SALESCONTRACT",
};

export const TypeTransferRequestData = [
  { key: "BOOKING", value: "BOOKING" },
  { key: "LOCKING", value: "LOCKING" },
  { key: "TTKQ", value: "TTKQ" },
  { key: "SALESCONTRACT", value: "HĐMB" },
];

export const AgentProject = [
  { key: "F0", value: "F0" },
  { key: "F1", value: "F1" },
];

export const TypeAgentProject = [
  { label: "F0", value: "F0" },
  { label: "F1", value: "F1" },
];

export const StatusIsFileSelect = [
  {
    key: 1,
    value: "Upload file",
  },
  {
    key: 2,
    value: "Link",
  },
];

export const LevelCalculatorRateK = [
  {
    id: 11,
    name: "Cơ chế nhận về",
    code: "CHUNG",
    mechanismRate: 5,
    rate: 100,
    mechanismRateElite: 0,
    rateElite: 100,
  },
  {
    id: 12,
    name: "Chuyên viên kinh doanh",
    code: "CVKD",
    mechanismRate: 1.5,
    rate: 30,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 13,
    name: "CVKD (phần Elite)",
    code: "CVKD_ELITE",
    mechanismRate: 0.2,
    rate: 4,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 14,
    name: "Giám đốc khối",
    code: "GDK",
    mechanismRate: 0.5,
    rate: 10,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 15,
    name: "Giám đốc vùng",
    code: "GDV",
    mechanismRate: 0.3,
    rate: 6,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 16,
    name: "Thưởng kinh doanh",
    code: "TKD",
    mechanismRate: 0.25,
    rate: 5,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 17,
    name: "Phát triển dự án",
    code: "PTDA",
    mechanismRate: 0.15,
    rate: 3,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 18,
    name: "Giới thiệu dự án",
    code: "GTDA",
    mechanismRate: 0.05,
    rate: 1,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 19,
    name: "Tổng giám đốc",
    code: "TGD",
    mechanismRate: 0.2,
    rate: 4,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 20,
    name: "Khối BE",
    code: "BE",
    mechanismRate: 0.1,
    rate: 2,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 21,
    name: "Giám đốc chi nhánh",
    code: "GDCN",
    mechanismRate: 0.15,
    rate: 3,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 22,
    name: "Phó tổng giám đốc",
    code: "PTGD",
    mechanismRate: 0.1,
    rate: 2,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 23,
    name: "Tổng cộng",
    code: "TOTAL",
    mechanismRate: 3.5,
    rate: 70,
    mechanismRateElite: 0,
    rateElite: 0,
  },
  {
    id: 24,
    name: "Còn lại",
    code: "REMAIN",
    mechanismRate: 0,
    rate: 0,
    mechanismRateElite: 0,
    rateElite: 0,
  },
];

export const DefaultMechanismRateProject = 3.5;
export const DefaultRateProject = 70;
